import { render } from "./ApplicationButton.vue?vue&type=template&id=880743c0"
import script from "./ApplicationButton.vue?vue&type=script&lang=js"
export * from "./ApplicationButton.vue?vue&type=script&lang=js"
script.render = render

export default script